import React, { Fragment, useState, useEffect } from "react";
import { Timestamp } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from "react-router-dom";
import { format } from 'date-fns';
import "react-calendar/dist/Calendar.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Button, Dropdown, Modal } from "react-bootstrap";
import {
    subscribeMeeting,
    getSubMeetings,
    getMeetingAgendas,
    getMeetingAnnouncements,
    getMeetingUsers,
    joinMeeting,
    getMeetingNotes,
    createMeetingNote,
    updateMeetingRecord,
    getMeetingAIDetail,
    getMeetingSpeakers,
    getMeetingSpeechAnalysis,
    getMeetingDecisions,
    subscribeLionNotes,
    createLionNote,
} from '../../features/meeting/meetingSlice';
import { toast } from 'react-hot-toast';
import profileService from '../../features/profile/profileService';

import {
    exportMeetingSummaryPDF,
    exportMeetingTranscriptPDF,
    exportMeetingSpeechDetailsPDF,
} from "./meetingupdate";
import { toDate } from "../../utils/meetingUtils";


// Şablon & Tip rozetleri
const TEMPLATE_LABELS = { '0': 'STANDART', '1': 'BİREBİR', '2': 'LION', '99': 'DİĞER' };
const TYPE_LABELS     = { '0': 'Fiziksel', '1': 'Online', '2': 'Hibrit', '3': 'Telefon', '4': 'Yazışma', '99': 'Diğer' };

 
const styles = {
    bgSuccessLight: {
        backgroundColor: 'rgba(40, 131, 167, 0.1) !important'
    },
    uploadContainer: {
        transition: 'all 0.3s ease',
        border: '2px dashed #ccc',
        borderRadius: '8px',
        padding: '1.5rem'
    },
    uploadContainerHover: {
        borderColor: '#b7c3cdff'
    },
    uploadContainerDragging: {
        borderColor: '#2072c9ff',
        backgroundColor: 'rgba(40, 120, 240, 0.1)',
        transform: 'scale(1.01)'
    },
    progressBar: {
        transition: 'width 0.5s ease'
    },
    audioPlayer: {
        width: '100%',
        marginTop: '10px'
    },
    selectedFile: {
        transition: 'all 0.2s ease'
    },
    selectedFileHover: {
        transform: 'translateY(-2px)',
        boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)!important'
    },
    summaryCard: {
        borderLeft: '4px solid #1785b8ff',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
    },
    summarySection: {
        background: '#fff',
        borderRadius: '8px',
        transition: 'all 0.2s ease'
    },
    summaryItem: {
        background: '#fff',
        borderRadius: '8px',
        padding: '15px',
        marginBottom: '10px',
        border: '1px solid #e9ecef',
        transition: 'all 0.2s ease'
    }
};

function MeetingDetail() {
    let { meetingId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState("meetingAIDetailSummary");
    const [activeTab2, setActiveTab2] = useState("meetingTranscript");
    const [activeToggle, setActiveToggle] = useState("about");
    const { user } = useSelector((state) => state.auth);
    const isAuthenticated = useSelector((state) => state.auth.user !== null);
    const myUserId = useSelector((state) => state.auth.user.uid);
    const isPremium = Boolean(user?.premium);
    const PRICING_URL = "https://beetinq.com/#pricing";
 


    const meetingState = useSelector((state) => state.meeting || {});
    const {
        meetings = [],
        meetingAnnouncements = [],
        meetingUsers = [],
        meetingNotes = [],
        meetingAgendas = [],
        meetingDecisions = [],
        meetingAIDetail = {},
        meetingSpeakers = [],
        meetingSpeechAnalysis = {},
        lionNotesBySection = {
            lastWeek: [],
            issues: [],
            opportunities: [],
            nextWeek: [],
        },
        isLoading,
        isError,
        message,
        errors,
        loadingStates
    } = meetingState;
    const meeting = meetingState.meeting ?? {};
    const meetingOnlineLink =
        meeting?.urlAttendee ||
        meeting?.urlattendee ||
        meeting?.urlHost ||
        meeting?.urlhost ||
        meeting?.url ||
        '';
    const meetingBriefing = meeting?.meetingDescription || meeting?.details || '';
    const myUserProfile = meetingUsers.find((u) => (u?.uid || u?.userId || u?.id) === myUserId);
    const isPremiumFinal = Boolean(user?.premium ?? myUserProfile?.premium);

    const INEFFICIENCY_TYPE_LABELS = {
        off_topic: "Gündem Dışı",
        repetition: "Tekrar",
        unclear_communication: "Belirsiz İletişim",
        excessive_silence_or_filler: "Aşırı Sessizlik/Dolgu",
    };
    
    // --- Template bayrakları (effect'lerden ve render'dan ÖNCE tanımlanmalı) ---
const tpl = String(meeting?.meetingTemplate ?? '0');
const IS_LION    = tpl === '2';
// LION bölümleri ve etiketleri (Firestore key -> görünen başlık)
const LION_SECTIONS = {
  lastWeek:       'Last Week',
  issues:         'Issues & Solutions',
  opportunities:  'Opportunities',
  nextWeek:       'Next Week',
};

// LION modal state’leri
const [lionModalOpen, setLionModalOpen] = useState(false);
const [lionSectionKey, setLionSectionKey] = useState(null);
const [lionForm, setLionForm] = useState({ title: '', details: '' });
const [lionSaving, setLionSaving] = useState(false);
const [selectedLionUserId, setSelectedLionUserId] = useState(null);
const [lionParticipants, setLionParticipants] = useState([]);

const openLionModal = (sectionKey) => {
  setLionSectionKey(sectionKey);
  setLionForm({ title: '', details: '' });
  setLionModalOpen(true);
};

const saveLionNote = async (e) => {
  e.preventDefault();
  if (!lionSectionKey) return;

  try {
    setLionSaving(true);
    const trimmedTitle = (lionForm.title || '').trim();
    const trimmedDetails = (lionForm.details || '').trim();

    await dispatch(createLionNote({
      meetingId,
      sectionKey: lionSectionKey,
      title: trimmedTitle,
      details: trimmedDetails,
    })).unwrap();

    setLionSaving(false);
    setLionModalOpen(false);
    setLionForm({ title: '', details: '' });
    toast.success('Not başarıyla kaydedildi.');
  } catch (err) {
    setLionSaving(false);
    toast.error('Not kaydedilemedi.');
    console.error(err);
  }
};


const IS_BIREBIR = tpl === '1';
const IS_STD     = tpl === '0' || tpl === '99';
 
const TEMPLATE_STYLES = {
  '2': { className: 'badge bg-primary',  icon: 'fa-shield' }, // LION
  '1': { className: 'badge bg-success',  icon: 'fa-user'   }, // BİREBİR
  '0': { className: 'badge bg-secondary',icon: 'fa-circle' }, // STANDART
  '99':{ className: 'badge bg-dark',     icon: 'fa-ellipsis-h' } // DİĞER
};
const [activeLionBox, setActiveLionBox] = useState(null);

    const [seconds, setSeconds] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [meetingRecord, setMeetingRecord] = useState(null);
    const meetingRecordDate = toDate(meetingRecord?.updateDate);
    const [isDragging, setIsDragging] = useState(false);

    // Text Summarization States
    const [textSummary, setTextSummary] = useState(null);
    const [isSummarizing, setIsSummarizing] = useState(false);
    const [summaryError, setSummaryError] = useState(null);

    const loadError = errors?.getMeeting;

    useEffect(() => {
        if (!isAuthenticated) { navigate('/login') }
        if (loadError) { toast.error(loadError || message); }
        const meetingSub = dispatch(subscribeMeeting(meetingId))
        dispatch(getMeetingUsers(meetingId))
        dispatch(getMeetingAgendas(meetingId))
        dispatch(getMeetingDecisions(meetingId))
        dispatch(getMeetingNotes(meetingId))
        dispatch(getMeetingAIDetail(meetingId))
        dispatch(getMeetingSpeakers(meetingId))
        dispatch(getMeetingSpeechAnalysis(meetingId))

        

        

        /*
        const interval = setInterval(() => {
            setSeconds(seconds => seconds + 1);
        }, 30000);
        */
       
        // return () => { if (isAuthenticated) { dispatch(reset()) } }
        //}, [isAuthenticated, navigate, isError, message, dispatch])
        return () => {
            meetingSub.then((action) => {
                const unsubscribe = action?.payload;
                if (typeof unsubscribe === 'function') unsubscribe();
            });
        };
    }, [isAuthenticated, navigate, seconds, loadError, message, dispatch, meetingId])

    // Toplantı verisi yüklendiğinde, ses kaydı bilgisini kontrol et
    useEffect(() => {
        if (meeting && (meeting.recordingUrl || meeting.meetingrecordurl)) {
            setMeetingRecord({
                url: meeting.recordingUrl || meeting.meetingrecordurl,
                name: meeting.recordingName || "Toplantı Ses Kaydı",
                updateDate: meeting.recordingUpdateDate || null
            });
        }
    }, [meeting]);

    const onMeetingJoin = e => {
        //e.prmeetingDefault();
        dispatch(joinMeeting(meetingId))
        setSeconds(seconds => seconds + 1);
    }

    useEffect(() => {
        if (!meeting) return;
        // LION template için sadece 'lion' sekmesini varsayılan yap
        if (IS_LION) setActiveToggle('lion');
        else if (IS_BIREBIR) setActiveToggle('notes');
        else setActiveToggle('about');
    }, [meeting, IS_LION, IS_BIREBIR]);

    const [noteTitle, setNoteTitle] = useState('')
    const [noteContext, setNoteContext] = useState('')

    const meetingNoteData = {
        title: noteTitle,
        context: noteContext,
        files: [],
        meetingId: meetingId,
        state: true,
        status: true,
        type: "1",
        noteId: "",
    };
useEffect(() => {
  if (!meetingId || !IS_LION) return;

  const promise = dispatch(subscribeLionNotes(meetingId));
  return () => {
    promise.then((action) => {
      const unsubscribe = action?.payload;
      if (typeof unsubscribe === 'function') unsubscribe();
    });
  };
}, [dispatch, meetingId, IS_LION]);

useEffect(() => {
  if (!Array.isArray(lionParticipants)) return;
  setSelectedLionUserId(null);
}, [lionParticipants]);

useEffect(() => {
  const users = Array.isArray(meeting?.users) ? meeting.users : [];
  if (!users.length) {
    setLionParticipants([]);
    return;
  }

  let isActive = true;
  const ids = users.map((u) => (typeof u === 'string' ? u : u?.uid || u?.userId || u?.id)).filter(Boolean);

  Promise.all(
    ids.map((id) =>
      profileService.getProfile(id).catch(() => null)
    )
  ).then((profiles) => {
    if (!isActive) return;
    const merged = ids.map((id, idx) => {
      const profile = profiles[idx];
      return profile ? { ...profile, id: profile.id || id, uid: profile.uid || id, userId: profile.userId || id } : { id, uid: id, userId: id };
    });
    setLionParticipants(merged);
  });

  return () => {
    isActive = false;
  };
}, [meeting?.users]);

const toggleLionUser = (userId) => {
  setSelectedLionUserId((prev) => (prev === userId ? null : userId));
};

const getLionUserLabel = (userId) => {
  const user =
    lionParticipants.find((u) => (u?.uid || u?.userId || u?.id) === userId) ||
    meetingUsers.find((u) => (u?.uid || u?.userId || u?.id) === userId);
  if (!user) return 'Bilinmeyen';
  const fullName = [user?.name, user?.surName].filter(Boolean).join(' ');
  return fullName || user?.userEmail || userId?.slice?.(0, 8) || 'Bilinmeyen';
};

const filterLionNotes = (notes) => {
  if (!Array.isArray(notes)) return [];
  if (!selectedLionUserId) return [];
  return notes.filter((note) => note.userId === selectedLionUserId);
};

const handlePremiumGate = (e) => {
  e.preventDefault();
  window.open(PRICING_URL, "_blank", "noopener,noreferrer");
};

const renderPremiumUpsell = (featureName) => (
  <div className="p-4 bg-white rounded border">
    <h4 className="text-info mb-2">{featureName} (Premium)</h4>
    <p className="text-muted mb-3">
      Bu özellik yalnızca Premium hesaplarda kullanılabilir.
    </p>
    <button className="btn btn-warning" onClick={handlePremiumGate}>
      ★ Fiyatlandırmayı Gör
    </button>
  </div>
);

// Not ekleme (diğer not sistemi için)
const onSubmitNote = (e) => {
  e.preventDefault();

  if (noteTitle !== '' || noteContext !== '') {
    dispatch(createMeetingNote(meetingNoteData));
    setNoteTitle('');
    setNoteContext('');
  }
};

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Maksimum 250MB olarak kontrol edelim
            const maxSize = 250 * 1024 * 1024; // 250MB in bytes
            if (file.size > maxSize) {
                toast.error('Dosya boyutu çok büyük. Lütfen 250MB\'dan küçük bir dosya seçin.');
                e.target.value = ''; // Input'u temizle
                return;
            }
            
            // Desteklenen ses formatlarını kontrol et
            const supportedTypes = ['audio/mpeg', 'audio/wav', 'audio/mp4', 'audio/aac', 'audio/ogg'];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const validExtensions = ['mp3', 'wav', 'm4a', 'aac', 'ogg', 'mp4'];
            
            if (!supportedTypes.includes(file.type) && !validExtensions.includes(fileExtension)) {
                toast.error('Desteklenmeyen dosya formatı. Lütfen MP3, WAV, M4A, AAC veya OGG formatında bir dosya seçin.');
                e.target.value = ''; // Input'u temizle
                return;
            }
            
            setSelectedFile(file);
            toast.success('Dosya başarıyla seçildi. Yüklemek için "Kayıt Yükle" butonuna tıklayın.');
        }
    };

    const handleRecordSubmit = async (e) => {
        e.preventDefault();
        if (!selectedFile) {
            toast.error('Lütfen bir ses dosyası seçin.');
            return;
        }

        try {
            setIsUploading(true);
            toast.loading('Ses kaydı yükleniyor...', { id: 'audioUpload' });
            
            // Kullanıcıya sayfadan ayrılmamasını hatırlatalım
            window.onbeforeunload = () => {
                return "Dosya yükleme işlemi devam ediyor. Sayfadan ayrılırsanız yükleme iptal edilecektir.";
            };
            
            const meetingData = {
                recordFile: selectedFile
            };
            
            // Bilgi mesajı ekleyelim
            //toast.info('Dosyanız güvenlik için benzersiz bir ad ile kaydedilecektir.', { duration: 3000 });
            
            // Dispatch the action to update meeting record
            const result = await dispatch(updateMeetingRecord({ 
                meetingData, 
                id: meeting.id,
                onProgress: (progress) => {
                    setUploadProgress(progress);
                }
            })).unwrap();
            
            // Update the meeting record state with the new URL and file name
            setMeetingRecord({
                url: result.recordingUrl,
                name: result.recordingName,
                updateDate: result.recordingUpdateDate
            });
            
            // Reset form state
            setIsUploading(false);
            setSelectedFile(null);
            setUploadProgress(0);
            
            // Sayfa ayrılma uyarısını kaldıralım
            window.onbeforeunload = null;
            
            toast.success('Ses kaydı başarıyla yüklendi!', { id: 'audioUpload' });
        } catch (error) {
            console.error("Upload error:", error);
            setIsUploading(false);
            setUploadProgress(0);
            
            // Sayfa ayrılma uyarısını kaldıralım
            window.onbeforeunload = null;
            
            // Daha açıklayıcı hata mesajları ekleyelim
            let errorMessage = 'Bilinmeyen bir hata oluştu';
            
            if (error.message) {
                if (error.message.includes('storage/unauthorized')) {
                    errorMessage = 'Ses kaydı yükleme izniniz bulunmuyor. Lütfen yöneticinizle iletişime geçin.';
                } else if (error.message.includes('storage/quota-exceeded')) {
                    errorMessage = 'Depolama limitinize ulaştınız. Lütfen yöneticinizle iletişime geçin.';
                } else if (error.message.includes('storage/canceled')) {
                    errorMessage = 'Yükleme iptal edildi.';
                } else if (error.message.includes('storage/unknown')) {
                    errorMessage = 'Sunucu bağlantısında bir sorun oluştu. Lütfen internet bağlantınızı kontrol edin.';
                } else {
                    errorMessage = `Yükleme sırasında bir hata oluştu: ${error.message}`;
                }
            }
            
            toast.error(errorMessage, { id: 'audioUpload' });
        }
    };

    const formatStartEndDate = (startDate, endDate) => {
        const startDateObj = toDate(startDate);
        const endDateObj = toDate(endDate);
        if (!startDateObj || !endDateObj) return '';
        return format(startDateObj, "dd MMM yyyy HH:mm") + " - " + format(endDateObj, "HH:mm");
    };

    // Drag and drop handlers
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const file = e.dataTransfer.files[0];
            // Reuse the same validation logic from handleFileChange
            const maxSize = 250 * 1024 * 1024;
            if (file.size > maxSize) {
                toast.error('Dosya boyutu çok büyük. Lütfen 250MB\'dan küçük bir dosya seçin.');
                return;
            }
            
            const supportedTypes = ['audio/mpeg', 'audio/wav', 'audio/mp4', 'audio/aac', 'audio/ogg'];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const validExtensions = ['mp3', 'wav', 'm4a', 'aac', 'ogg'];
            
            if (!supportedTypes.includes(file.type) && !validExtensions.includes(fileExtension)) {
                toast.error('Desteklenmeyen dosya formatı. Lütfen MP3, WAV, M4A, AAC veya OGG formatında bir dosya seçin.');
                return;
            }
            
            setSelectedFile(file);
            toast.success('Dosya başarıyla seçildi. Yüklemek için "Kayıt Yükle" butonuna tıklayın.');
        }
    };

    const getFormattedTimeFromMillis = (millis) => {
        try {
            const firestoreTimestamp = Timestamp.fromMillis(millis);
            const date = firestoreTimestamp.toDate();
            const time = date.toLocaleTimeString('tr-TR', {
                hour: '2-digit',
                minute: '2-digit',
            });
            return time;
        } catch (error) {
            console.error("Geçersiz zaman değeri:", error);
            return "";
        }
    };

    function formatToMinutesAndSeconds(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60);
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-lg-12">
                    <div className="profile card card-body px-3 pt-3 pb-0">
                        <div className="profile-head">
                            
                            <div className="profile-info">
                               
                                <div className="profile-details">
                                    <div className="profile-name px-3 pt-2">
                                        <h4 className="text-info mb-0">{meeting.title}</h4>
                                        <p>
                                            Katılımcı Sayısı:  {meeting.users?.length}
                                            <br />
                                            Tarih Saat: {formatStartEndDate(meeting.startDate, meeting.endDate)}
                                        </p>
                                    </div>

                                    {/* LION template için About dropdown'ını gizle */}
                                    {!IS_LION && (
                                        <Dropdown className="dropdown ms-auto" onClick={() => setActiveToggle("about")}>
                                            <div className="ticket-icon44  ms-0 d-none d-sm-inline-block" onClick={() => setActiveToggle("about")}>
                                                <i className="fa fa-info fs-16" aria-hidden="true"></i>
                                            </div>
                                        </Dropdown>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">

                <div className="col-xl-4">
                    <div className="row">

                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    {!meeting.users?.includes(myUserId) ? (
                                        <>
                                            <a onClick={() => onMeetingJoin()} >
                                                <div className="media">
                                                    <span className="me-3">
                                                        <i className="fa fa-check"></i>
                                                    </span>
                                                    <div className="media-body">
                                                        <h4 className="">1- Toplantıya Katıl</h4>
                                                    </div>
                                                </div>
                                            </a>
                                        </>
                                    ) : (
                                        <>
                                            {new Date(new Date(meeting.startDate).getTime() - 5 * 60000) <= new Date() && 
                                             new Date(new Date(meeting.endDate).getTime() + 5 * 60000) >= new Date() ? (
                                                <>
                                                    {meeting && Array.isArray(meeting.adminUsers) && meeting.adminUsers.includes(myUserId) ? (
                                                        <a href={meeting.urlHost || "#"}>
                                                            <div className="media">
                                                                <span className="me-3">
                                                                    <i className="fa fa-play"></i>
                                                                </span>
                                                                <div className="media-body">
                                                                    <h4 className="">Toplantı Devam Ediyor</h4>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    ) : (
                                                        <a href={meeting && meeting.urlAttendee ? meeting.urlAttendee : "#"}>
                                                            <div className="media">
                                                                <span className="me-3">
                                                                    <i className="fa fa-play"></i>
                                                                </span>
                                                                <div className="media-body">
                                                                    <h4 className="">Toplantı Devam Ediyor</h4>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {new Date(meeting.startDate) >= new Date() && new Date(meeting.endDate) >= new Date() ? (
                                                        <>
                                                            <div className="media">
                                                                <span className="me-3">
                                                                    <i className="fa fa-check"></i>
                                                                </span>
                                                                <div className="media-body">
                                                                    <h5 className="">Toplantı Başlamadı</h5>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="media">
                                                                <span className="me-3">
                                                                    <i className="fa fa-check"></i>
                                                                </span>
                                                                <div className="media-body">
                                                                    <h5 className="">Toplantı Sona Erdi</h5>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        
                                        </>
                                    )}
                            <Modal show={lionModalOpen} onHide={() => setLionModalOpen(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>
      {lionSectionKey ? LION_SECTIONS[lionSectionKey] : 'LION Note'}
    </Modal.Title>
  </Modal.Header>
  
  <form onSubmit={saveLionNote}>
    <Modal.Body>
      <div className="mb-3">
        <label className="form-label">Başlık</label>
        <input
          type="text"
          className="form-control"
          value={lionForm.title}
          onChange={(e) => setLionForm((f) => ({ ...f, title: e.target.value }))}
          placeholder="Örn: Önceki haftanın özeti"
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Detay</label>
        <textarea
          className="form-control"
          rows={4}
          value={lionForm.details}
          onChange={(e) => setLionForm((f) => ({ ...f, details: e.target.value }))}
          placeholder="Not ayrıntıları"
        />
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={() => setLionModalOpen(false)}>
        Kapat
      </Button>
      <Button variant="primary" type="submit" disabled={lionSaving}>
        {lionSaving ? 'Kaydediliyor...' : 'Kaydet'}
      </Button>
    </Modal.Footer>
  </form>
</Modal>

 </div>
                            </div>
                        </div>

         

                        <div className="col-lg-12">
                            <div className="card">

                                <div className="card-body">

                                  {/* Hakkında  */}
<div className="media align-items-center border-bottom p-2" onClick={() => setActiveToggle("about")}>
  <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
    <i className="fa fa-info fs-16" aria-hidden="true"></i>
  </div>
  <div className="media-body">
    <h5 className="mt-0 mb-0">Hakkında</h5>
  </div>
</div>


                                    {/* LION Paneli */}
                                    {IS_LION && (
                                        <div className="media align-items-center border-bottom p-2" onClick={() => setActiveToggle("lion")}>
                                            <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-shield fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0" onClick={() => setActiveToggle("lion")}>LION</h5>
                                            </div>
                                        </div>
                                    )}

                                    {/* LION template için My Notes sekmesini gizle */}
                                    {!IS_LION && (
                                        <div className="media align-items-center border-bottom p-2" onClick={() => setActiveToggle("notes")}>
                                            <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-edit fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0" onClick={() => setActiveToggle("notes")}>Notlarım</h5>
                                            </div>
                                        </div>
                                    )}

                                    {/* Gündem menü itemı */}
                                    {!IS_LION && !IS_BIREBIR && (
                                        <div
                                            className="media align-items-center border-bottom p-2"
                                            onClick={isPremiumFinal ? () => setActiveToggle("agenda") : handlePremiumGate}
                                        >
                                            <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-calendar fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">
                                                    Gündem {!isPremiumFinal && <span className="ms-2 text-warning">★ Premium</span>}
                                                </h5>
                                            </div>
                                        </div>
                                    )}

                                    {/* Kararlar menü itemı */}
                                    {!IS_LION && !IS_BIREBIR && (
                                        <div
                                            className="media align-items-center border-bottom p-2"
                                            onClick={isPremiumFinal ? () => setActiveToggle("decision") : handlePremiumGate}
                                        >
                                            <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-check fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">
                                                    Kararlar {!isPremiumFinal && <span className="ms-2 text-warning">★ Premium</span>}
                                                </h5>
                                            </div>
                                        </div>
                                    )}

                                  {/* Katılımcılar – BİREBİR’de gizle */}
{!IS_BIREBIR && (
  <div className="media align-items-center border-bottom p-2" onClick={() => setActiveToggle("participants")}>
    <div className="ticket-icon44 ms-0 me-3 d-none d-sm-inline-block">
      <i className="fa fa-users fs-16" aria-hidden="true"></i>
    </div>
    <div className="media-body">
      <h5 className="mt-0 mb-0">Katılımcılar</h5>
    </div>
  </div>
)}


                                    {/* LION template için Meeting Record sekmesini gizle */}
                                    {!IS_LION && (
                                        <div
                                            className="media align-items-center border-bottom p-2"
                                            onClick={isPremiumFinal ? () => setActiveToggle("record") : handlePremiumGate}
                                        >
                                            <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-microphone fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">
                                                    Toplantı Kaydı {!isPremiumFinal && <span className="ms-2 text-warning">★ Premium</span>}
                                                </h5>
                                            </div>
                                        </div>
                                    )}

                                   {/* Toplantı Dökümü: yalnızca transkript varsa ve BİREBİR değilse */}
                                    {meeting?.isTranscribed && !IS_BIREBIR && (
                                        <div
                                            className="media align-items-center border-bottom p-2"
                                            onClick={() => setActiveToggle("transcript")}
                                        >
                                            <div className="ticket-icon44 ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-pencil fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">Toplantı Dökümü</h5>
                                            </div>
                                        </div>
                                    )}

                                    {/* Yapay Zeka ile Analiz: yalnızca transkript varsa ve BİREBİR değilse */}
                                    {meeting?.isTranscribed && !IS_BIREBIR && (
                                        <div
                                            className="media align-items-center border-bottom p-2"
                                            onClick={() => setActiveToggle("meetingAI")}
                                        >
                                            <div className="ticket-icon44 ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-file-text fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">Yapay Zeka ile Analiz</h5>
                                            </div>
                                        </div>
                                    )}

                              <div className="media align-items-center border-bottom p-2">
                                <div className="w-100 d-grid gap-2">
                                  <button
                                    className="btn w-100 text-start border border-primary-subtle rounded-3 py-2 px-3"
                                    style={{ background: "linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%)" }}
                                    onClick={async () => {
                                      try {
                                        await exportMeetingSummaryPDF({
                                          meeting,
                                          agendas: meetingAgendas,
                                          decisions: meetingDecisions,
                                          users: meetingUsers,
                                          notes: meetingNotes,
                                          speakers: meetingSpeakers,
                                          aiDetail: meetingAIDetail,
                                          lionNotesBySection: IS_LION ? lionNotesBySection : null,
                                        });
                                      } catch (e) {
                                        console.error("PDF export error:", e);
                                      }
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-2">
                                      <i className="fa fa-file-pdf-o text-primary" />
                                      <span className="fw-semibold text-primary">Toplantı Özeti</span>
                                    </div>
                                    <div className="small text-muted ms-4">Başlık, tarih, katılımcılar, gündem ve kararlar</div>
                                  </button>

                                  <button
                                    className="btn w-100 text-start border border-primary-subtle rounded-3 py-2 px-3"
                                    style={{ background: "linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%)" }}
                                    onClick={async () => {
                                      try {
                                        await exportMeetingTranscriptPDF({
                                          meeting,
                                          agendas: meetingAgendas,
                                          decisions: meetingDecisions,
                                          users: meetingUsers,
                                          notes: meetingNotes,
                                          speakers: meetingSpeakers,
                                          aiDetail: meetingAIDetail,
                                          lionNotesBySection: IS_LION ? lionNotesBySection : null,
                                        });
                                      } catch (e) {
                                        console.error("PDF export error:", e);
                                      }
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-2">
                                      <i className="fa fa-file-text-o text-primary" />
                                      <span className="fw-semibold text-primary">Toplantı Dökümü</span>
                                    </div>
                                    <div className="small text-muted ms-4">Toplantı metni (transcript)</div>
                                  </button>

                                  <button
                                    className="btn w-100 text-start border border-primary-subtle rounded-3 py-2 px-3"
                                    style={{ background: "linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%)" }}
                                    onClick={async () => {
                                      try {
                                        await exportMeetingSpeechDetailsPDF({
                                          meeting,
                                          agendas: meetingAgendas,
                                          decisions: meetingDecisions,
                                          users: meetingUsers,
                                          notes: meetingNotes,
                                          speakers: meetingSpeakers,
                                          aiDetail: meetingAIDetail,
                                          lionNotesBySection: IS_LION ? lionNotesBySection : null,
                                        });
                                      } catch (e) {
                                        console.error("PDF export error:", e);
                                      }
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-2">
                                      <i className="fa fa-microphone text-primary" />
                                      <span className="fw-semibold text-primary">Konuşma Detayları</span>
                                    </div>
                                    <div className="small text-muted ms-4">Konuşmacı ve zaman aralığı bazlı içerik</div>
                                  </button>
                                </div>
                              </div>
  </div>

                            </div>
                        </div>

                    </div>
                </div>

                <div className="col-xl-8">
                    <div className="card">
                        <div className="card-body">
                            <div className="profile-tab">
                                <div className="custom-tab-1">

                                    <div className="tab-content">

                                        <div id="about" className={`tab-pane fade ${activeToggle === "about" ? "active show" : ""}`}>
                                            <h4 className="text-info mb-4">Hakkında</h4>
                                            <p className="mb-2">{meetingBriefing}</p>
                                            {meetingOnlineLink && (
                                                <div className="mt-3">
                                                    <h6 className="text-info mb-2">Online Toplantı Linki</h6>
                                                    <a
                                                        href={meetingOnlineLink}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ wordBreak: 'break-all' }}
                                                    >
                                                        {meetingOnlineLink}
                                                    </a>
                                                </div>
                                            )}
                                        </div>

{/* LION Paneli – SAĞDA, sadece LION şablonda */}
{IS_LION && (
  <div
    id="lion"
    className={`tab-pane fade ${activeToggle === "lion" ? "active show" : ""}`}
  >
    <h4 className="text-info mb-4">LION</h4>
    <div className="mb-3">
      <div className="small text-muted mb-2">Katılımcı Filtrele</div>
      <div className="d-flex flex-wrap gap-3">
        {lionParticipants.map((u) => {
          const uid = u?.uid || u?.userId || u?.id;
          if (!uid) return null;
          const label = [u?.name, u?.surName].filter(Boolean).join(' ') || u?.userEmail || 'Bilinmeyen';
          const checked = selectedLionUserId === uid;
          return (
            <label key={uid} className="d-flex align-items-center m-0">
                <input
                  type="checkbox"
                  className="me-2"
                  checked={checked}
                  onChange={() => toggleLionUser(uid)}
                />
              <span className="text-dark" style={{ whiteSpace: 'nowrap' }}>{label}</span>
            </label>
          );
        })}
      </div>
    </div>
    <div className="row g-3">
      {/* Last Week */}
      <div className="col-md-6">
        <div
          className="p-4 rounded"
          style={{ background: "#ff80b3", cursor: "pointer" }}
          onClick={() => openLionModal("lastWeek")}
        >
          <h5 className="text-white mb-0">Last Week</h5>
        </div>
        <div className="mt-2 bg-white rounded p-2">
          {filterLionNotes(lionNotesBySection.lastWeek).length === 0 ? (
            <small className="text-muted">Henüz not yok.</small>
          ) : (
            <ul className="mb-0" style={{ listStyle: "disc", paddingLeft: 18 }}>
              {filterLionNotes(lionNotesBySection.lastWeek).map((note) => (
                <li key={note.id}>
                  <strong>{note.title}</strong>
                  {note.context && <> – {note.context}</>}
                  <div className="small text-muted">Yazan: {getLionUserLabel(note.userId)}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Issues & Solutions */}
      <div className="col-md-6">
        <div
          className="p-4 rounded"
          style={{ background: "#2fb5ff", cursor: "pointer" }}
          onClick={() => openLionModal("issues")}
        >
          <h5 className="text-white mb-0">Issues &amp; Solutions</h5>
        </div>
        <div className="mt-2 bg-white rounded p-2">
          {filterLionNotes(lionNotesBySection.issues).length === 0 ? (
            <small className="text-muted">Henüz not yok.</small>
          ) : (
            <ul className="mb-0" style={{ listStyle: "disc", paddingLeft: 18 }}>
              {filterLionNotes(lionNotesBySection.issues).map((note) => (
                <li key={note.id}>
                  <strong>{note.title}</strong>
                  {note.context && <> – {note.context}</>}
                  <div className="small text-muted">Yazan: {getLionUserLabel(note.userId)}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Opportunities */}
      <div className="col-md-6">
        <div
          className="p-4 rounded"
          style={{ background: "#23d3ee", cursor: "pointer" }}
          onClick={() => openLionModal("opportunities")}
        >
          <h5 className="text-white mb-0">Opportunities</h5>
        </div>
        <div className="mt-2 bg-white rounded p-2">
          {filterLionNotes(lionNotesBySection.opportunities).length === 0 ? (
            <small className="text-muted">Henüz not yok.</small>
          ) : (
            <ul className="mb-0" style={{ listStyle: "disc", paddingLeft: 18 }}>
              {filterLionNotes(lionNotesBySection.opportunities).map((note) => (
                <li key={note.id}>
                  <strong>{note.title}</strong>
                  {note.context && <> – {note.context}</>}
                  <div className="small text-muted">Yazan: {getLionUserLabel(note.userId)}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Next Week */}
      <div className="col-md-6">
        <div
          className="p-4 rounded"
          style={{ background: "#b3a4ff", cursor: "pointer" }}
          onClick={() => openLionModal("nextWeek")}
        >
          <h5 className="text-white mb-0">Next Week</h5>
        </div>
        <div className="mt-2 bg-white rounded p-2">
          {filterLionNotes(lionNotesBySection.nextWeek).length === 0 ? (
            <small className="text-muted">Henüz not yok.</small>
          ) : (
            <ul className="mb-0" style={{ listStyle: "disc", paddingLeft: 18 }}>
              {filterLionNotes(lionNotesBySection.nextWeek).map((note) => (
                <li key={note.id}>
                  <strong>{note.title}</strong>
                  {note.context && <> – {note.context}</>}
                  <div className="small text-muted">Yazan: {getLionUserLabel(note.userId)}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  </div>
)}
                                        {/* Meeting Record Tab - LION template için gizle */}
                                        {!IS_LION && (
                                            <div id="record" className={`tab-pane fade ${activeToggle === "record" ? "active show" : ""}`}>
                                                {isPremiumFinal ? (
                                                <>
                                                <h4 className="text-info mb-4">Toplantı Kaydı</h4>
                                                
                                                {/* Mevcut kayıt bölümü */}
                                                {meetingRecord && meetingRecord.url ? (
                                                    <div className="existing-recording p-3 mb-4 bg-white rounded shadow-sm">
                                                        <h6 className="text-info mb-3">
                                                            <i className="fa fa-headphones me-2"></i>
                                                            Mevcut Kayıt
                                                        </h6>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div className="d-flex align-items-center">
                                                                <i className="fa fa-file-audio-o fa-2x text-info me-3"></i>
                                                                <div className="text-start">
                                                                    <p className="mb-0 fw-bold text-truncate" style={{ maxWidth: "250px" }}>
                                                                        {meetingRecord.name}
                                                                    </p>
                                                                    {meetingRecordDate && (
                                                                        <small className="text-muted">
                                                                            Yüklenme: {meetingRecordDate.toLocaleString('tr-TR')}
                                                                        </small>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <a 
                                                                    href={meetingRecord.url} 
                                                                    target="_blank" 
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-sm btn-outline-info me-2"
                                                                >
                                                                    <i className="fa fa-external-link me-1"></i>Aç
                                                                </a>
                                                                <a 
                                                                    href={meetingRecord.url} 
                                                                    download={meetingRecord.name}
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                >
                                                                    <i className="fa fa-download me-1"></i>İndir
                                                                </a>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="mt-3">
                                                            <audio 
                                                                controls 
                                                                src={meetingRecord.url} 
                                                                className="audio-player"
                                                                style={styles.audioPlayer}
                                                                controlsList="nodownload"
                                                                preload="metadata"
                                                            >
                                                                Tarayıcınız ses elementi desteklemiyor.
                                                            </audio>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}
                                                
                                                <div className="upload-area mb-4">
                                                    <form onSubmit={handleRecordSubmit} className="text-center">
                                                        <div 
                                                            style={{
                                                                ...styles.uploadContainer,
                                                                ...(isDragging ? styles.uploadContainerDragging : {})
                                                            }}
                                                            className="position-relative"
                                                            onDragOver={handleDragOver}
                                                            onDragLeave={handleDragLeave}
                                                            onDrop={handleDrop}
                                                        >
                                                            {isUploading ? (
                                                                <div className="mb-4">
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <span className="text-muted">Yükleniyor...</span>
                                                                        <span className="fw-bold">{uploadProgress}%</span>
                                                                    </div>
                                                                    <div className="progress mb-3" style={{ height: "20px" }}>
                                                                        <div
                                                                            className="progress-bar progress-bar-striped progress-bar-animated bg-info"
                                                                            role="progressbar"
                                                                            style={{ width: `${uploadProgress}%`, ...styles.progressBar }}
                                                                            aria-valuenow={uploadProgress}
                                                                            aria-valuemin="0"
                                                                            aria-valuemax="100"
                                                                        >
                                                                            {uploadProgress}%
                                                                        </div>
                                                                    </div>
                                                                    <div className="alert alert-warning">
                                                                        <i className="fa fa-exclamation-triangle me-2"></i>
                                                                        Lütfen yükleme tamamlanana kadar sayfadan ayrılmayın.
                                                                    </div>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-sm btn-outline-danger mt-2"
                                                                        onClick={() => {
                                                                            setIsUploading(false);
                                                                            setUploadProgress(0);
                                                                            window.onbeforeunload = null;
                                                                            toast.error('Yükleme iptal edildi', { id: 'audioUpload' });
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-times me-1"></i>
                                                                        İptal Et
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {selectedFile ? (
                                                                        <div style={styles.selectedFile} className="p-3 bg-white rounded shadow-sm">
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <div className="d-flex align-items-center">
                                                                                    <i className="fa fa-file-audio-o fa-2x text-info me-3"></i>
                                                                                    <div className="text-start">
                                                                                        <p className="mb-0 fw-bold text-truncate" style={{maxWidth: "250px"}}>{selectedFile.name}</p>
                                                                                        <small className="text-muted">{(selectedFile.size / (1024 * 1024)).toFixed(2)} MB</small>
                                                                                    </div>
                                                                                </div>
                                                                                <button 
                                                                                    type="button" 
                                                                                    className="btn btn-sm btn-outline-danger"
                                                                                    onClick={() => setSelectedFile(null)}
                                                                                >
                                                                                    <i className="fa fa-times me-1"></i>Kaldır
                                                                                </button>
                                                                            </div>
                                                                            
                                                                            <div className="mt-4 d-flex justify-content-center">
                                                                                <button 
                                                                                    type="submit" 
                                                                                    className="btn btn-success px-4 py-2"
                                                                                    disabled={isUploading}
                                                                                >
                                                                                    <i className="fa fa-cloud-upload me-2"></i>
                                                                                    Kayıt Yükle
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <div className="text-center mb-3">
                                                                                <i className="fa fa-cloud-upload fa-4x text-info mb-3"></i>
                                                                                <h5 className="fw-bold">Ses kaydı yüklemek için buraya sürükleyin</h5>
                                                                                <p className="text-muted">veya</p>
                                                                            </div>
                                                                            <input
                                                                                type="file"
                                                                                id="meeting-audio-upload"
                                                                                className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
                                                                                accept="audio/*,.mp3,.wav,.m4a,.aac,.ogg,.mp4"
                                                                                onChange={handleFileChange}
                                                                                style={{ cursor: 'pointer' }}
                                                                            />
                                                                            <button type="button" className="btn btn-info px-4 py-2">
                                                                                <i className="fa fa-file-audio-o me-2"></i>Dosya Seç
                                                                            </button>
                                                                            <div className="mt-3">
                                                                                <small className="text-muted">Desteklenen formatlar: MP3, WAV, M4A, AAC, OGG, MP4</small>
                                                                                <br />
                                                                                <small className="text-muted">Maksimum dosya boyutu: 250MB</small>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </form>
                                                </div>
                                                </>
                                                ) : (
                                                    renderPremiumUpsell("Toplantı Kaydı")
                                                )}
                                            </div>
                                        )}

                                        <div id="transcript" className={`tab-pane fade ${activeToggle === "transcript" ? "active show" : ""}`}>

                                            <div className="custom-tab-1">
                                                
                                                <ul className="nav nav-tabs">
                                                    <li className="nav-item" onClick={() => setActiveTab2("meetingTranscript")}>
                                                        <Link to="#meetingTranscript" data-toggle="tab" className={`nav-link ${activeTab2 === "meetingTranscript" ? "active show" : ""}`}>Toplantı Dökümü</Link>
                                                    </li>
                                                    <li className="nav-item" onClick={() => setActiveTab2("meetingSpeakers")}>
                                                        <Link to="#meetingSpeakers" data-toggle="tab" className={`nav-link ${activeTab2 === "meetingSpeakers" ? "active show" : ""}`}>Toplantı Konuşmaları</Link>
                                                    </li>
                                                </ul>

                                                <div className="tab-content">

                                                    <div id="meetingTranscript" className={`tab-pane fade ${activeTab2 === "meetingTranscript" ? "active show" : ""}`} >
                                                        
                                                        <h5 className="text-info mb-2 mt-5">Toplantı Dökümü</h5>
                                                        <p className="mb-15">
                                                            {meeting.meetingTranscripts}
                                                        </p>
                                                        
                                                    </div>

                                                    <div id="meetingSpeakers" className={`tab-pane fade ${activeTab2 === "meetingSpeakers" ? "active show" : ""}`} >
                                                        
                                                        <h5 className="text-info mb-2 mt-5">Toplantı Konuşmaları</h5>
                                                        {meetingSpeakers.map((list, index) => (
                                                            <div key={index} className="media mb-5 align-items-center event-list">
                                                                <div className="p-3 text-center me-3 date-bx bgl-info">
                                                                    <h2 className="mb-0 text-secondary fs-16 font-w600">
                                                                        {formatToMinutesAndSeconds(list.start)}
                                                                    </h2>
                                                                    <h5 className="mb-1 text-black fs-16 ">
                                                                        {formatToMinutesAndSeconds(list.end)}
                                                                    </h5>
                                                                </div>
                                                                <div className="media-body px-0">
                                                                    <h6 className="mt-0 mb-0 fs-16 text-bold">{list.speaker}</h6>
                                                                    <p className="mt-0 mb-3 fs-14 text-bold">{list.text}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        
                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        {/* Gündem секmesi - Premium */}
                                        {!IS_LION && !IS_BIREBIR && (
                                            <div
                                                id="agenda"
                                                className={`tab-pane fade ${activeToggle === "agenda" ? "active show" : ""}`}
                                            >
                                                {isPremiumFinal ? (
                                                    <>
                                                        <h4 className="text-info mb-4">Gündem</h4>
                                                        {meetingAgendas.map((list, index) => (
                                                            <div key={index} className="media mb-5 align-items-center event-list">
                                                                <div className="p-3 text-center me-3 date-bx bgl-info">
                                                                    <h2 className="mb-0 text-secondary fs-16 font-w600">
                                                                        {getFormattedTimeFromMillis(list.startTime)}
                                                                    </h2>
                                                                    <h5 className="mb-1 text-black fs-16 ">
                                                                        {getFormattedTimeFromMillis(list.endTime)}
                                                                    </h5>
                                                                </div>
                                                                <div className="media-body px-0">
                                                                    <h6 className="mt-0 mb-0 fs-16 text-bold">{list.title}</h6>
                                                                    <p className="mt-0 mb-3 fs-14 text-bold">{list.details}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    renderPremiumUpsell("Gündem")
                                                )}
                                            </div>
                                        )}

                                        {/* Katılımcılar sekmesi – LION template için gizle */}
                                        {!IS_BIREBIR && (
                                            <div id="participants" className={`tab-pane fade ${activeToggle === "participants" ? "active show" : ""}`}>
                                                <h4 className="text-info mb-4">Katılımcılar</h4>
                                                <div className="mb-2">
                                                    {meetingUsers.map((list, index) => (
                                                        <Link key={index} to={"/Profile/" + list.userId}>
                                                            <div className="media pb-3 border-bottom mb-3 align-items-center">
                                                                <div className="media-image me-2">
                                                                    {list.thumbnail == "" ? (
                                                                        <img src={"https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"} alt="" />
                                                                    ) : (
                                                                        <img src={list.thumbnail} alt="" />
                                                                    )}
                                                                </div>
                                                                <div className="media-body">
                                                                    <h6 className="fs-16 mb-0">{list.name + " " + list.surName}</h6>
                                                                    <div className="d-flex">
                                                                        <span className="fs-14 me-auto text-secondary">
                                                                            {list.businessName + " " + list.job}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* Notes Tab - LION template için gizle */}
                                        {!IS_LION && (
                                            <div id="notes" className={`tab-pane fade ${activeToggle === "notes" ? "active show" : ""}`}>
                                                <h4 className="text-info mb-4">Notlarım</h4>
                                                <div className="mb-2">
                                                    <div className="post-input">
                                                        <form onSubmit={onSubmitNote}>
                                                            <input type="text" value={noteTitle} onChange={(e) => setNoteTitle(e.target.value)} className="form-control input-default " placeholder="Başlık" />
                                                            <textarea value={noteContext} onChange={(e) => setNoteContext(e.target.value)} name="textarea" id="textarea" cols={30} rows={5} className="form-control bg-transparent" placeholder="Detay" />
                                                            <button className='btn btn-info ms-1' type='submit'>Ekle</button>
                                                        </form>
                                                    </div>
                                                    <PerfectScrollbar
                                                        id="DZ_W_TimeLine"
                                                        className="widget-timeline dz-scroll  ps ps--active-y" >
                                                        <ul className="timeline">
                                                            {meetingNotes.map((list, index) => (
                                                                <li key={index}>
                                                                    <div className="timeline-badge dark"></div>
                                                                    <Link to="" className="timeline-panel text-muted">
                                                                        <h6 className="mb-0">{list.title}</h6>
                                                                        <p>{list.context}</p>
                                                                    </Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </PerfectScrollbar>
                                                </div>
                                            </div>
                                        )}

                                        <div id="chat" className={`tab-pane fade ${activeToggle === "chat" ? "active show" : ""}`}>
                                            <h4 className="text-info mb-4">Sohbet</h4>
                                            <p className="mb-2"></p>
                                        </div>

                                        {/* Kararlar секmesi - Premium */}
                                        {!IS_LION && !IS_BIREBIR && (
                                            <div
                                                id="decision"
                                                className={`tab-pane fade ${activeToggle === "decision" ? "active show" : ""}`}
                                            >
                                                {isPremiumFinal ? (
                                                    <>
                                                        <h4 className="text-info mb-4">Kararlar</h4>

                                                        {(!meetingDecisions || meetingDecisions.length === 0) && (
                                                            <div className="text-muted fs-14">Henüz karar eklenmemiş.</div>
                                                        )}

                                                        {meetingDecisions?.map((list, index) => (
                                                            <div key={index} className="media mb-5 align-items-center event-list">
                                                                <div className="p-3 text-center me-3 date-bx bgl-info">
                                                                    {/* Tarih/saat alanı varsa burada gösterebilirsin */}
                                                                    {/* örn: <h5 className="mb-0 text-black fs-14">{formatDecisionDate(list.createdAt)}</h5> */}
                                                                </div>
                                                                <div className="media-body px-0">
                                                                    <h6 className="mt-0 mb-0 fs-16 text-bold">{list.title}</h6>
                                                                    <p className="mt-0 mb-3 fs-14 text-bold">{list.details}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    renderPremiumUpsell("Kararlar")
                                                )}
                                            </div>
                                        )}

                                        <div id="files" className={`tab-pane fade ${activeToggle === "files" ? "active show" : ""}`}>
                                            <h4 className="text-info mb-4">Dosyalar</h4>
                                            <p className="mb-2"></p>
                                        </div>

                                        <div id="meetingAI" className={`tab-pane fade ${activeToggle === "meetingAI" ? "active show" : ""}`}>
                                         
                                            <div className="custom-tab-1">
                                                
                                                <ul className="nav nav-tabs">
                                                    <li className="nav-item" onClick={() => setActiveTab("meetingAIDetailSummary")}>
                                                        <Link to="#meetingAIDetailSummary" data-toggle="tab" className={`nav-link ${activeTab === "meetingAIDetailSummary" ? "active show" : ""}`}>Özet</Link>
                                                    </li>
                                                    <li className="nav-item" onClick={() => setActiveTab("meetingAIDetailAgenda")}>
                                                        <Link to="#meetingAIDetailAgenda" data-toggle="tab" className={`nav-link ${activeTab === "meetingAIDetailAgenda" ? "active show" : ""}`}>Gündem</Link>
                                                    </li>
                                                    <li className="nav-item" onClick={() => setActiveTab("meetingAIDetailDecisions")} >
                                                        <Link to="#meetingAIDetailDecisions" data-toggle="tab" className={`nav-link ${activeTab === "meetingAIDetailDecisions" ? "active show" : ""}`}>Karar</Link>
                                                    </li>
                                                    <li className="nav-item" onClick={() => setActiveTab("meetingAIDetailNextAgendaSuggestion")} >
                                                        <Link to="#meetingAIDetailNextAgendaSuggestion" data-toggle="tab" className={`nav-link ${activeTab === "meetingAIDetailNextAgendaSuggestion" ? "active show" : ""}`}>Öneri</Link>
                                                    </li>
                                                </ul>

                                                <div className="tab-content">

                                                    <div id="meetingAIDetailSummary" className={`tab-pane fade ${activeTab === "meetingAIDetailSummary" ? "active show" : ""}`} >
                                                        
                                                        <h5 className="text-info mb-2 mt-5">Toplantı Özeti</h5>
                                                        <p className="mb-15">
                                                            {meetingAIDetail.summary}
                                                        </p>

                                                        {meetingSpeechAnalysis?.analysis && (
                                                            <div className="mt-4">
                                                                <h5 className="text-info mb-2">Konuşma Analizi</h5>
                                                                <div className="row">
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="p-3 border rounded">
                                                                            <div className="fw-bold text-dark">Genel Özet</div>
                                                                            <div className="text-dark mt-1">
                                                                                {meetingSpeechAnalysis.analysis.generalSummary || "-"}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="p-3 border rounded">
                                                                            <div className="fw-bold text-dark">Verimlilik</div>
                                                                            <div className="text-dark mt-1">
                                                                                %{meetingSpeechAnalysis.analysis.efficiencyPercent ?? "-"}
                                                                            </div>
                                                                            <div className="small text-muted mt-2">
                                                                                Üretken: {meetingSpeechAnalysis.analysis.productiveMinutes ?? "-"} dk ·
                                                                                Üretken olmayan: {meetingSpeechAnalysis.analysis.nonProductiveMinutes ?? "-"} dk ·
                                                                                Konu dışı: {meetingSpeechAnalysis.analysis.offTopicMinutes ?? "-"} dk
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="row">
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="p-3 border rounded">
                                                                            <div className="fw-bold text-dark">En Üretken Konuşmacılar</div>
                                                                            <div className="text-dark mt-1">
                                                                                {Array.isArray(meetingSpeechAnalysis.analysis.mostProductiveSpeakers) && meetingSpeechAnalysis.analysis.mostProductiveSpeakers.length
                                                                                    ? meetingSpeechAnalysis.analysis.mostProductiveSpeakers.join(", ")
                                                                                    : "-"}
                                                                            </div>
                                                                            {meetingSpeechAnalysis.analysis.mostProductiveSpeakersReason && (
                                                                                <div className="small text-muted mt-2">
                                                                                    {meetingSpeechAnalysis.analysis.mostProductiveSpeakersReason}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="p-3 border rounded">
                                                                            <div className="fw-bold text-dark">En Az Üretken Konuşmacılar</div>
                                                                            <div className="text-dark mt-1">
                                                                                {Array.isArray(meetingSpeechAnalysis.analysis.leastProductiveSpeakers) && meetingSpeechAnalysis.analysis.leastProductiveSpeakers.length
                                                                                    ? meetingSpeechAnalysis.analysis.leastProductiveSpeakers.join(", ")
                                                                                    : "-"}
                                                                            </div>
                                                                            {meetingSpeechAnalysis.analysis.leastProductiveSpeakersReason && (
                                                                                <div className="small text-muted mt-2">
                                                                                    {meetingSpeechAnalysis.analysis.leastProductiveSpeakersReason}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {Array.isArray(meetingSpeechAnalysis.analysis.speakerPerformances) && meetingSpeechAnalysis.analysis.speakerPerformances.length > 0 && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Konuşmacı Performansları</h6>
                                                                        <div className="row">
                                                                            {meetingSpeechAnalysis.analysis.speakerPerformances.map((perf, idx) => (
                                                                                <div className="col-md-6 mb-3" key={idx}>
                                                                                    <div className="p-3 border rounded">
                                                                                        <div className="fw-bold text-dark">{perf?.speaker || "-"}</div>
                                                                                        <div className="text-dark mt-1">{perf?.summary || "-"}</div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {Array.isArray(meetingSpeechAnalysis.analysis.inefficiencyReasons) && meetingSpeechAnalysis.analysis.inefficiencyReasons.length > 0 && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Verimsizlik Nedenleri</h6>
                                                                        <div className="row">
                                                                            {meetingSpeechAnalysis.analysis.inefficiencyReasons.map((item, idx) => (
                                                                                <div className="col-md-6 mb-3" key={idx}>
                                                                                    <div className="p-3 border rounded">
                                                                                        <div className="fw-bold text-dark">
                                                                                            {INEFFICIENCY_TYPE_LABELS[item?.type] || (item?.type || "-").toString()}
                                                                                        </div>
                                                                                        <div className="text-dark mt-1">
                                                                                            {item?.details || "-"}
                                                                                        </div>
                                                                                        <div className="small text-muted mt-2">
                                                                                            Süre: {item?.minutes ?? "-"} dk
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {meetingSpeechAnalysis?.analysis?.participantRecommendations && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Katılımcı Önerileri</h6>
                                                                        <div className="row">
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Gerekli</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {Array.isArray(meetingSpeechAnalysis.analysis.participantRecommendations.required) &&
                                                                                        meetingSpeechAnalysis.analysis.participantRecommendations.required.length
                                                                                            ? meetingSpeechAnalysis.analysis.participantRecommendations.required.join(", ")
                                                                                            : "-"}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Opsiyonel</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {Array.isArray(meetingSpeechAnalysis.analysis.participantRecommendations.optional) &&
                                                                                        meetingSpeechAnalysis.analysis.participantRecommendations.optional.length
                                                                                            ? meetingSpeechAnalysis.analysis.participantRecommendations.optional.join(", ")
                                                                                            : "-"}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Gerekli Değil</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {Array.isArray(meetingSpeechAnalysis.analysis.participantRecommendations.notRequired) &&
                                                                                        meetingSpeechAnalysis.analysis.participantRecommendations.notRequired.length
                                                                                            ? meetingSpeechAnalysis.analysis.participantRecommendations.notRequired.join(", ")
                                                                                            : "-"}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {meetingSpeechAnalysis?.analysis?.meetingFormatSuggestion && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Toplantı Formatı Önerisi</h6>
                                                                    <div className="p-3 border rounded">
                                                                        <div className="text-dark">
                                                                            {meetingSpeechAnalysis.analysis.meetingFormatSuggestion.reason || "-"}
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                )}

                                                                {meetingSpeechAnalysis?.analysis?.timeOptimization && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Zaman Optimizasyonu</h6>
                                                                        <div className="row">
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Orijinal Süre</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {meetingSpeechAnalysis.analysis.timeOptimization.originalMinutes ?? "-"} dk
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Tasarruf</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {meetingSpeechAnalysis.analysis.timeOptimization.savedMinutes ?? "-"} dk
                                                                                        {meetingSpeechAnalysis.analysis.timeOptimization.savedPercent != null && (
                                                                                            <span> (%{meetingSpeechAnalysis.analysis.timeOptimization.savedPercent})</span>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Optimize Süre</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {meetingSpeechAnalysis.analysis.timeOptimization.optimizedMinutes ?? "-"} dk
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {Array.isArray(meetingSpeechAnalysis?.analysis?.nextMeetingRecommendations) && meetingSpeechAnalysis.analysis.nextMeetingRecommendations.length > 0 && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Bir Sonraki Toplantı Önerileri</h6>
                                                                        <div className="p-3 border rounded">
                                                                            <ul className="mb-0">
                                                                                {meetingSpeechAnalysis.analysis.nextMeetingRecommendations.map((item, idx) => (
                                                                                    <li key={idx}>{item}</li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                        
                                                    </div>

                                                    <div id="meetingAIDetailAgenda" className={`tab-pane fade ${activeTab === "meetingAIDetailAgenda" ? "active show" : ""}`}>
                                                        
                                                        <h5 className="text-info mb-2 mt-5">Gerçekleşen Gündem</h5>
                                                        <div className="mb-15">
                                                            <ul className="mb-0">
                                                                {Array.isArray(meetingAIDetail.agenda) &&
                                                                meetingAIDetail.agenda.map((item, index) => (
                                                                    <li key={index}> <i className="fa fa-circle fs-12" aria-hidden="true"></i> {item}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        
                                                    </div>

                                                    <div id="meetingAIDetailDecisions" className={`tab-pane fade ${activeTab === "meetingAIDetailDecisions" ? "active show" : ""}`}>
                                                        
                                                        <h5 className="text-info mb-2 mt-5">Alınan Kararlar</h5>
                                                        <div className="mb-15">
                                                            <ul className="mb-0">
                                                                {Array.isArray(meetingAIDetail.decisions) &&
                                                                meetingAIDetail.decisions.map((item, index) => (
                                                                    <li key={index}> <i className="fa fa-circle fs-12" aria-hidden="true"></i> {item}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        
                                                    </div>

                                                    <div id="meetingAIDetailNextAgendaSuggestion" className={`tab-pane fade ${activeTab === "meetingAIDetailNextAgendaSuggestion" ? "active show" : ""}`}>
                                                        
                                                        <h5 className="text-info mb-2 mt-5">Bir Sonraki Toplantı için Gündem Önerisi</h5>
                                                        <div className="mb-15">
                                                            <ul className="mb-0">
                                                                {Array.isArray(meetingAIDetail.nextAgendaSuggestion) &&
                                                                meetingAIDetail.nextAgendaSuggestion.map((item, index) => (
                                                                    <li key={index}> <i className="fa fa-circle fs-12" aria-hidden="true"></i> {item}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </Fragment >

    )
}

export default MeetingDetail
